import React from 'react'
import myself from '../../Assests/myself.jpg'

export default function AboutMe() {
    return (
        <div className=' mx-12 mt-12'>
            <div className='flex justify-center gap-2 items-center mb-8 md:mb-16'>
                <div className=' w-12 h-1 bg-white'></div>
                <h3 className=' text-white font-bold lg:text-3xl md:text-2xl text-lg text-center'>About Me</h3>
                <div className=' w-12 h-1 bg-white'></div>
            </div>
            <div className=' flex justify-center' id='about-me'>
                <div className='flex lg:flex-row  flex-col'>
                    <div className=' lg:w-1/2 flex justify-center '>
                        <img src={myself} alt="" className='w-[75%] border rounded-full shadow-lg shadow-white' />
                    </div>
                    <div className=' lg:w-1/2 lg:mt-12 flex flex-col lg:justify-start justify-center text-center lg:text-start'>
                        <h4 className=' text-white font-bold text-2xl mt-4'>Hello!</h4>
                        <h4 className=' text-white font-bold text-2xl mt-4'>I'm <span className=' text-green-500'>Abdullah</span></h4>
                        <p className=' text-white mt-4 opacity-70'>
                            A passionate and scrupulous web developer with a degree in Computer Science and Engineering. I have been exploring MERN Stack for the last several months and have developed some full stack projects. I believe in continuous learning and am eager to learn new technology. I'm honest with my time and work and I always look for improving code efficiency.
                        </p>
                        <div className='mt-10'>
                            <a href='#contact-me' className='mt-4 text-white border uppercase font-bold p-4 rounded-lg shadow-lg hover:text-green-500 shadow-white'>Hire me</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
